import React, { createContext, useState, useEffect } from "react";
import { verifyToken } from "./api/api";
import { useNavigate } from "react-router-dom";

export const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [loginDetails, setLoginDetails] = useState(null);
    const [orgDetails, setOrgDetails] = useState(null);
    const [currentApp, setCurrentApp] = useState(null);
    const [appId,setAppId] = useState(null);

    const navigate = useNavigate();

    useEffect(() => {
        const checkAuthentication = async () => {
            const token = localStorage.getItem("token");
            if (!token) {
                setIsAuthenticated(false);
                navigate("/login");
                return;
            }

            try {
                const response = await verifyToken(token);
                if (response.data.valid) {
                    setIsAuthenticated(true);
                    let decoded = response.data.decoded;
                    setLoginDetails(decoded.user);
                    setOrgDetails(decoded.organization);
                    setCurrentApp(decoded.currentApp);
                    setAppId(decoded.currentApp.id);
                } else {
                    setIsAuthenticated(false);
                    localStorage.removeItem("token");
                    navigate("/login");
                }
            } catch (error) {
                console.error("Token verification failed:", error);
                setIsAuthenticated(false);
                localStorage.removeItem("token");
                navigate("/login");
            }
        };

        checkAuthentication();
    }, [navigate]);

    return (
        <GlobalContext.Provider
            value={{
                isAuthenticated,
                loginDetails,
                orgDetails,
                currentApp,
                appId,
                setLoginDetails,
                setOrgDetails,
                setCurrentApp,
                setAppId,
            }}
        >
            {children}
        </GlobalContext.Provider>
    );
};
